module.exports = __webpack_public_path__ + "media/newstyle/images/norton-c019ef825726a4d62fccae5e5df61844.svg";